export { getGooglePredictions } from './googleSearchPredictions';
